module.exports = __webpack_public_path__ + "img/suanlichuanbo.5052da29.png";